module.exports = __webpack_public_path__ + "static/media/resume-builder-video-1080p.10d98e88.mp4";